import { render } from "./transfer-course-flow-dialogs.vue?vue&type=template&id=6fe454be"
import script from "./transfer-course-flow-dialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-course-flow-dialogs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/shared/components/transfer-course-dialog/transfer-course-flow-dialogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fe454be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fe454be', __exports__)) {
    api.reload('6fe454be', __exports__)
  }
  
  module.hot.accept("./transfer-course-flow-dialogs.vue?vue&type=template&id=6fe454be", () => {
    api.rerender('6fe454be', render)
  })

}


export default __exports__